import {
  Form,
  Space,
} from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import BannerForm from '../../forms/BannerForm';
import { addBanner } from '../../services/bannerServices';

function AddBanner() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      setErrors([]);
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        if (values[key]) {
          if (key.includes('image')) {
            formData.append(key, values[key].file);
          } else {
            formData.append(key, values[key]);
          }
        }
      });
      const res = await addBanner(formData);
      if (res.status === 'success') {
        navigate('/admin/banners');
      }
    } catch (e) {
      setErrors(e.response.data.errors);
    }
    setLoading(false);
  };

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <ArrowLeftOutlined
        style={{ fontSize: '20px' }}
        onClick={() => navigate('/admin/banners')}
      />
      <BannerForm
        form={form}
        errors={errors}
        handleSubmit={handleSubmit}
        loading={loading}
      />
    </Space>
  );
}

export default AddBanner;
